import React, { useState } from 'react';
import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../firebase';
import { Link } from 'react-router-dom';
import './ForgotPassword.css';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);

  const validateEmail = (email) => {
    return /\S+@\S+\.\S+/.test(email);
  };

  const handleReset = async (e) => {
    e.preventDefault();
    
    if (!email) {
      setError('Por favor, digite seu endereço de e-mail.');
      return;
    }

    if (!validateEmail(email)) {
      setError('Por favor, digite um endereço de e-mail válido.');
      return;
    }

    setLoading(true);
    setError('');
    setMessage('');

    try {
      await sendPasswordResetEmail(auth, email);
      setEmailSent(true);
      setMessage('E-mail de redefinição de senha enviado! Verifique sua caixa de entrada e siga as instruções para redefinir sua senha.');
    } catch (err) {
      setError(getErrorMessage(err.code));
    } finally {
      setLoading(false);
    }
  };

  const getErrorMessage = (errorCode) => {
    switch (errorCode) {
      case 'auth/user-not-found':
        return 'Nenhuma conta encontrada com este endereço de e-mail.';
      case 'auth/invalid-email':
        return 'Por favor, digite um endereço de e-mail válido.';
      case 'auth/too-many-requests':
        return 'Muitas tentativas de redefinição de senha. Tente novamente mais tarde.';
      default:
        return 'Falha ao enviar e-mail de redefinição de senha. Tente novamente.';
    }
  };

  const handleResend = () => {
    setEmailSent(false);
    setMessage('');
    setError('');
  };

  return (
    <div className="forgot-password-container">
      <div className="forgot-password-card">
        <div className="forgot-password-header">
          <div className="icon-container">
            <span className="forgot-icon">🔐</span>
          </div>
          <h1>Esqueceu a Senha?</h1>
          <p>
            {!emailSent 
              ? "Sem problemas! Digite seu endereço de e-mail e enviaremos um link para redefinir sua senha."
              : "Enviamos um link de redefinição de senha para você!"
            }
          </p>
        </div>

        {!emailSent ? (
          <form onSubmit={handleReset} className="forgot-password-form">
            <div className="form-group">
              <label htmlFor="email">Endereço de E-mail</label>
              <div className="input-wrapper">
                <input
                  id="email"
                  type="email"
                  placeholder="Digite seu endereço de e-mail"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    if (error) setError('');
                  }}
                  className={error ? 'error' : ''}
                  required
                />
                <span className="input-icon">📧</span>
              </div>
            </div>

            {error && (
              <div className="error-message">
                <span className="error-icon">⚠️</span>
                {error}
              </div>
            )}

            <button 
              type="submit" 
              className="reset-button"
              disabled={loading || !email}
            >
              {loading ? (
                <>
                  <span className="spinner"></span>
                  Enviando...
                </>
              ) : (
                <>
                  📤 Enviar Link de Redefinição
                </>
              )}
            </button>
          </form>
        ) : (
          <div className="success-content">
            {message && (
              <div className="success-message">
                <span className="success-icon">✅</span>
                {message}
              </div>
            )}
            
            <div className="success-actions">
              <button 
                onClick={handleResend}
                className="resend-button"
              >
                📤 Enviar Outro E-mail
              </button>
              
              <div className="email-tips">
                <h4>Não recebeu o e-mail?</h4>
                <ul>
                  <li>Verifique sua pasta de spam ou lixo eletrônico</li>
                  <li>Certifique-se de que digitou o endereço de e-mail correto</li>
                  <li>Aguarde alguns minutos para o e-mail chegar</li>
                  <li>Tente clicar em "Enviar Outro E-mail" se necessário</li>
                </ul>
              </div>
            </div>
          </div>
        )}

        <div className="forgot-password-footer">
          <div className="back-to-login">
            <span>Lembrou da senha? </span>
            <Link to="/login">Faça login</Link>
          </div>
          
          <div className="help-links">
            <Link to="/register" className="help-link">
              Não tem uma conta? Cadastre-se
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
